// Loader
export const HIDE_LOADER ="HIDE_LOADER";
export const SHOW_LOADER ="SHOW_LOADER";

// API calls
export const API ="API";
export const API_ERROR_RESPONSE ="API_ERROR_RESPONSE";
export const API_SAVE_RESPONSE ="API_SAVE_RESPONSE";

// get all posts
export const GET_POSTS ="GET_POSTS";
export const SAVE_POSTS ="SAVE_POSTS";
export const GET_POST_DETAILS ="GET_POST_DETAILS";
export const SAVE_POST_DETAILS ="SAVE_POST_DETAILS";

// set page no
export const SET_PAGE_NO = 'SET_PAGE_NO';